import MenuBookIcon from '@material-ui/icons/MenuBook';

import { LoginLogsList } from './List/List';
import { LoginLogsShow } from './Show/Show';

export {
	LoginLogsList,
	LoginLogsShow,
};

export const loginLogsResource = {
	list: LoginLogsList,
	show: LoginLogsShow,
	icon: MenuBookIcon,
};
